import { SendSmsDto, TechnicalService } from "../api";

export const TechnicalApi = {
  sendSms: async (controlBlockId: string, phoneNumber: string): Promise<boolean> => {
    const payload: SendSmsDto = {controlBlockId, phoneNumber};

    await TechnicalService.postApiTechnicalSendSms(payload);
    return true;
  },
};

export default TechnicalApi;
